/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { negocioConfiguracion } from '../../conexiones';
import IItemUnidadAccion from './entidades/itemUnidadAccion';
export default class ModeloItemUnidad {
    public consultarItemsUnidadesPorUnidad(ItemId: number) {
        return manejadorRest<IRespuesta<IItemUnidadAccion>>(
            () => negocioConfiguracion.post('ItemsUnidades/ConsultarItemsUnidadesUnidadCompuesta', { ItemId }),
            true
        );
    }
}
